import React from 'react';

// Define the original Tube Icon as a component
interface TubeIconProps {
  color?: string;
  className?: string;
}
const TubeIcon: React.FC<TubeIconProps> = ({ color, className }) => (
  <svg viewBox="0 0 24 27" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M17.2727 0.642883H7.45455C7.15345 0.642883 6.90909 0.882883 6.90909 1.1786C6.90909 1.47431 7.15345 1.71431 7.45455 1.71431H8V22.0715C8 24.435 9.95709 26.3572 12.3636 26.3572C14.7702 26.3572 16.7273 24.435 16.7273 22.0715V1.71431H17.2727C17.5738 1.71431 17.8182 1.47431 17.8182 1.1786C17.8182 0.882883 17.5738 0.642883 17.2727 0.642883ZM12.3636 25.2857C10.5593 25.2857 9.09091 23.8436 9.09091 22.0715V11.3572H15.6364V22.0715C15.6364 23.8436 14.168 25.2857 12.3636 25.2857ZM15.6364 10.2857H9.09091V1.71431H15.6364V10.2857Z" fill="#0C3058"/>
    <path d="M9.09091 22.0715C9.09091 23.8436 10.5593 25.2857 12.3636 25.2857C14.168 25.2857 15.6364 23.8436 15.6364 22.0715V11.3572H9.09091V22.0715Z" fill="#FFFFFF"/>
    <path d="M15.6364 10.2857H9.09091V1.71431H15.6364V10.2857Z" fill={color || "#8F081E"}/>
  </svg>
);

export default TubeIcon;
